/**
 * Whether the connect-your-agent step is finished in this browser
 * Story 586: Web sign-up tells new users to connect their coding agent
 *
 * Set when the person closes the step, chooses to add a repository from it,
 * or completes a command-line sign-in. Stored per browser, not per account.
 */

export const CONNECT_STEP_FINISHED_KEY = 'ceetrix_connect_step_finished';

const FINISHED_VALUE = 'true';

export function isConnectStepFinished(): boolean {
  return localStorage.getItem(CONNECT_STEP_FINISHED_KEY) === FINISHED_VALUE;
}

export function markConnectStepFinished(): void {
  localStorage.setItem(CONNECT_STEP_FINISHED_KEY, FINISHED_VALUE);
}
